import { Skeleton, Box } from '@machobear/design-system'
import { StyledTableCell, SingleTableRow } from '@/components/listings-table'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints } from '@/styles'

const SkeletonState = () => {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const isDesktop = useMediaQuery(`(max-width: ${breakpoints.desktop})`)

  const StyledSkeletonRow = () => {
    return (
      <>
        {isMobile ? (
          <SingleTableRow>
            <StyledTableCell colSpan="8" width="85%">
              <Box display="flex" flexDirection="column" gap="xxsmall" padding="xsmall">
                <Skeleton.Shape width={288} height={24} />
                <Skeleton.Shape width={186} height={24} />
              </Box>
            </StyledTableCell>
            <StyledTableCell colSpan="1" width="15%">
              <Box>
                <Skeleton.Shape width={32} height={32} />
              </Box>
            </StyledTableCell>
          </SingleTableRow>
        ) : (
          <SingleTableRow>
            <StyledTableCell>
              <Box width="full" padding="xsmall">
                <Skeleton.Shape width="95%" height={24} />
              </Box>
            </StyledTableCell>
            <StyledTableCell>
              <Box width="full" padding="xsmall">
                <Skeleton.Shape width="95%" height={24} />
              </Box>
            </StyledTableCell>
            <StyledTableCell>
              <Box width="full" padding="xsmall">
                <Skeleton.Shape width="95%" height={24} />
              </Box>
            </StyledTableCell>
            <StyledTableCell>
              <Box width="full" padding="xsmall">
                <Skeleton.Shape width="95%" height={24} />
              </Box>
            </StyledTableCell>
            <StyledTableCell>
              <Box width="full" padding="xsmall">
                <Skeleton.Shape width="95%" height={24} />
              </Box>
            </StyledTableCell>
            <StyledTableCell>
              <Box width="full" padding="xsmall">
                <Skeleton.Shape width="95%" height={24} />
              </Box>
            </StyledTableCell>
            <StyledTableCell>
              <Box width="full" padding="xsmall">
                <Skeleton.Shape width="95%" height={24} />
              </Box>
            </StyledTableCell>
            {!isDesktop && (
              <StyledTableCell>
                <Box width="full" padding="xsmall">
                  <Skeleton.Shape width="95%" height={24} />
                </Box>
              </StyledTableCell>
            )}
          </SingleTableRow>
        )}
      </>
    )
  }

  const SKELETON_ROWS = 7

  return (
    <>
      {Array.from({ length: SKELETON_ROWS }, (_, index) => (
        <StyledSkeletonRow key={'listing-skeleton-row-' + index} />
      ))}
    </>
  )
}

export default SkeletonState
